import React from "react";
import classNames from "../../utils/classNames";
import withStyles from "@material-ui/core/styles/withStyles";
import MuiTableCell from "@material-ui/core/TableCell/TableCell";
import { TableColumn, TableDataType, ColumnDataType } from "./types";
import { Theme } from "@material-ui/core";
import formatDate from "../../utils/formatDate";

const styles = (theme: Theme) => ({
  cell: {
    padding: "10px 56px 10px 24px"
  },
  firstGroupItem: {
    borderLeft: `1px solid ${theme.palette.divider}`
  },
  lastGroupItem: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
});

const renderCellContent = (column: TableColumn, data: TableDataType) => {
  const { type } = column;
  if (type === ColumnDataType.Date) {
    return <span>{formatDate.condensed(data as Date)}</span>;
  }
  return <span>{data}</span>;
};

type Props = {
  classes: any;
  data: TableDataType;
  row: any;
  column: TableColumn;
  firstGroupItem?: boolean;
  lastGroupItem?: boolean;
};

const TableCell = ({
  classes,
  data,
  row,
  firstGroupItem,
  lastGroupItem,
  column
}: Props) => {
  const { renderCell } = column;
  const cellClasses = [classes.cell];
  if (firstGroupItem) {
    cellClasses.push(classes.firstGroupItem);
  }
  if (lastGroupItem) {
    cellClasses.push(classes.lastGroupItem);
  }

  return (
    <MuiTableCell className={classNames(cellClasses)}>
      {renderCell ? renderCell(data, row) : renderCellContent(column, data)}
    </MuiTableCell>
  );
};

export default withStyles(styles)(TableCell);
